/**
 * Sade Markdown → HTML önizleyici (dış kütüphane yok).
 *
 * Yalnız ÖNİZLEME içindir; sitedeki gerçek çıktıyı Astro üretir. Desteklenenler:
 * başlık, kalın, italik, satır içi kod, bağlantı, görsel, madde/numaralı liste,
 * alıntı, kod bloğu, yatay çizgi.
 *
 * Güvenlik: metnin TAMAMI önce HTML'den kaçırılır; etiketleri yalnız bu dosya
 * üretir. Bağlantı ve görsel adresleri izinli şemalarla sınırlıdır.
 */
const kacir = (s: string) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
const guvenliAdres = (u: string) => /^(\/(?!\/)|#|https?:\/\/|mailto:|tel:)/i.test(u);

/** `coz`: görsel yolunu tarayıcıda gösterilebilir adrese çevirir (kütüphane görseli → blob adresi). */
function satirIci(ham: string, coz: (yol: string) => string): string {
  const parcalar: string[] = [];
  const sakla = (html: string) => `\u0000${parcalar.push(html) - 1}\u0000`;
  let s = kacir(ham);
  s = s.replace(/`([^`]+)`/g, (_, kod: string) => sakla(`<code>${kod}</code>`));
  s = s.replace(/!\[([^\]]*)\]\(([^)\s]+)\)/g, (_, alt: string, u: string) => (guvenliAdres(u) ? sakla(`<img alt="${alt}" src="${kacir(coz(u.replace(/&amp;/g, '&')))}">`) : alt));
  s = s.replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, (_, yazi: string, u: string) => (guvenliAdres(u) ? `${sakla(`<a href="${u}" target="_blank" rel="noreferrer">`)}${yazi}${sakla('</a>')}` : yazi));
  s = s.replace(/&lt;(https?:\/\/[^\s&]+)&gt;/g, (_, u: string) => sakla(`<a href="${u}" target="_blank" rel="noreferrer">${u}</a>`));
  s = s.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>').replace(/(^|[^*])\*([^*\s][^*]*)\*/g, '$1<em>$2</em>');
  // eslint-disable-next-line no-control-regex
  return s.replace(/\u0000(\d+)\u0000/g, (_, n: string) => parcalar[Number(n)]);
}

export function markdownHtml(md: string, coz: (yol: string) => string = (y) => y): string {
  const satirlar = md.replace(/\r\n?/g, '\n').split('\n');
  const cikti: string[] = [];
  let paragraf: string[] = [];
  let liste: { tur: 'ul' | 'ol'; ogeler: string[] } | null = null;
  let alinti: string[] = [];
  const bosalt = () => {
    if (paragraf.length) { cikti.push(`<p>${satirIci(paragraf.join(' '), coz)}</p>`); paragraf = []; }
    if (liste) { cikti.push(`<${liste.tur}>${liste.ogeler.map((o) => `<li>${satirIci(o, coz)}</li>`).join('')}</${liste.tur}>`); liste = null; }
    if (alinti.length) { cikti.push(`<blockquote>${satirIci(alinti.join(' '), coz)}</blockquote>`); alinti = []; }
  };

  for (let i = 0; i < satirlar.length; i++) {
    const satir = satirlar[i];
    if (/^```/.test(satir)) {
      bosalt();
      const kod: string[] = [];
      for (i++; i < satirlar.length && !/^```/.test(satirlar[i]); i++) kod.push(satirlar[i]);
      cikti.push(`<pre><code>${kacir(kod.join('\n'))}</code></pre>`);
      continue;
    }
    const baslik = /^(#{1,6})\s+(.*)$/.exec(satir);
    const madde = /^\s*[-*+]\s+(.*)$/.exec(satir);
    const numara = /^\s*\d+[.)]\s+(.*)$/.exec(satir);
    const alintiSatir = /^>\s?(.*)$/.exec(satir);
    if (!satir.trim()) bosalt();
    else if (baslik) { bosalt(); cikti.push(`<h${baslik[1].length}>${satirIci(baslik[2], coz)}</h${baslik[1].length}>`); }
    else if (/^(-{3,}|\*{3,}|_{3,})\s*$/.test(satir)) { bosalt(); cikti.push('<hr>'); }
    else if (madde || numara) {
      const tur = madde ? 'ul' : 'ol';
      if (paragraf.length || alinti.length || (liste && liste.tur !== tur)) bosalt();
      liste ??= { tur, ogeler: [] };
      liste.ogeler.push((madde ?? numara)![1]);
    } else if (alintiSatir) {
      if (paragraf.length || liste) bosalt();
      alinti.push(alintiSatir[1]);
    } else if (liste && /^\s{2,}\S/.test(satir)) liste.ogeler[liste.ogeler.length - 1] += ` ${satir.trim()}`;
    else { if (liste || alinti.length) bosalt(); paragraf.push(satir.trim()); }
  }
  bosalt();
  return cikti.join('\n');
}

/** Metinde geçen kütüphane görsel yolları (/img/panel/…). */
export const panelGorselleri = (md: string) => [...new Set([...md.matchAll(/\/img\/panel\/[a-f0-9]{32}\.(?:jpg|png|webp)/g)].map((m) => m[0]))];
